import { Injectable, EventEmitter } from '@angular/core';

import {
    SignalRService,
    SignalREventService,
    ToastrService,
    DataArray,
    AccountSetting,
    AccountSettingGroup,
    SecurityQuestion
} from './../index';

@Injectable()
export class AccountService {
    public accountSettingGroupsChange: EventEmitter<AccountSettingGroup[]> = new EventEmitter<AccountSettingGroup[]>();
    public accountSettingsChange: EventEmitter<AccountSettingGroup> = new EventEmitter<AccountSettingGroup>();
    public securityQuestionsChanged: EventEmitter<SecurityQuestion[]> = new EventEmitter<SecurityQuestion[]>();

    public accountSettings: DataArray<AccountSetting> = new DataArray<AccountSetting>(1);
    public accountSettingGroups: DataArray<AccountSettingGroup> = new DataArray<AccountSettingGroup>(1);

    public questions: DataArray<SecurityQuestion> = new DataArray<SecurityQuestion>(1);

    constructor(
        private _signalRService: SignalRService,
        private _signalREventService: SignalREventService
    ) {
        this.registerOnServerEvents();
    }

    public isEnabled(userId: number, settingId: number): Promise<boolean> {
        return this._signalRService.invoke('IsSettingEnabled', userId, settingId).then((result: boolean) => result);
    }

    public toggleSetting(userId: number, settingId: number): void {
        this._signalRService.invoke('ToggleSetting', userId, settingId);
    }

    public getGroups(): void {
        this._signalRService.invoke('GetSettingGroups');
    }

    public getSecurityQuestions(userId: number): void {
        this._signalRService.invoke('GetSecurityQuestions', userId);
    }

    public getSettings(groupId: number, userId: number): void {
        this._signalRService.invoke('GetSettingsForGroup', groupId, userId);
    }

    public setStartPage(userId: number, page: string): void {
        this._signalRService.invoke('SetStartPage', userId, page);
    }

    public changePassword(userId: number, oldPassword: string, newPassword: string): void {
        this._signalRService.invoke('ChangePassword', userId, oldPassword, newPassword);
    }

    public changeQuestionAnswer(userId: number, questionId: number, answer: string): void {
        this._signalRService.invoke('ChangeAnswer', userId, questionId, answer);
    }

    public clearAnswer(userId: number, questionId: number): void {
        this._signalRService.invoke('ClearAnswer', userId, questionId);
    }

    private onAccountSettings(info: any): void {
        const accountSettingGroup: AccountSettingGroup = this.accountSettingGroups.GetByMap(0, info.Data.GroupId);
        accountSettingGroup.AccountSettings.Clear();
        for (const setting of info.Data.Settings) {
            accountSettingGroup.AccountSettings.update($.extend(new AccountSetting(), setting), true);
        }

        this.accountSettingsChange.emit(accountSettingGroup);
    }

    private onAccountSettingGroups(info: any): void {
        this.accountSettingGroups.Clear();
        for (const group of info.Data.Groups) {
            this.accountSettingGroups.update($.extend(new AccountSettingGroup(), group), true);
        }

        this.accountSettingGroupsChange.emit(this.accountSettingGroups.Data);
    }

    private onAccountSettingToggled(info: any): void {
        const setting: AccountSetting = $.extend(new AccountSetting(), info.Data.Setting);
        setting.Enabled = info.Data.Enabled;
        this.accountSettings.update(setting, false, setting.Id);
        this.accountSettingGroups.GetByMap(0, info.Data.GroupId).AccountSettings.update(setting, false, setting.Id);
        this.accountSettingsChange.emit(this.accountSettingGroups.GetByMap(0, info.Data.GroupId));
    }

    private onSecurityQuestions(info: any): void {
        this.questions.init();

        for (const question of info.Data.Questions) {
            const securityQuestion: SecurityQuestion = $.extend(new SecurityQuestion(), question);
            if (info.Data.AnsweredQuestions.filter((value: any) => value.QuestionId == securityQuestion.Id).length > 0) {
                securityQuestion.Answered = true;
            }
            this.questions.update(securityQuestion, true);
        }
        this.securityQuestionsChanged.emit(this.questions.Data);
    }

    private registerOnServerEvents() {
        this._signalREventService.registerAdvanced(this, 'accountSettingGroups', (info: any) => this.onAccountSettingGroups(info));
        this._signalREventService.registerAdvanced(this, 'accountSettings', (info: any) => this.onAccountSettings(info));
        this._signalREventService.registerAdvanced(this, 'accountSettingToggled', (info: any) => this.onAccountSettingToggled(info));
        this._signalREventService.registerAdvanced(this, 'securityQuestions', (info: any) => this.onSecurityQuestions(info));
    }


    public deregisterOnServerEvents(): void {
        this._signalREventService.deregister('AssociationService');
    }
}
